<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('title')}" id="title"
					formControlName="title" placeholder="">
				<label for="title">Title*</label>
			</div>
			<p *ngIf="showError('title')" class="text-danger">
				<span *ngIf="f.title.errors?.required">
					Required
				</span>
				<span *ngIf="f.title.errors?.incorrect">
					{{customError.title}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="mb-editor text_editor_container">
				<quill-editor id="text" formControlName="text" [modules]="quillConfig" [placeholder]="'Text'"></quill-editor>
			</div>
			<p *ngIf="showError('text')" class="text-danger">
				<span *ngIf="f.text.errors?.required">
					Required
				</span>
				<span *ngIf="f.text.errors?.incorrect">
					{{customError.text}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>